import type { ReactNode } from 'react'
import React from 'react'

import * as S from './AnalyticsToolbar.styled'

type AnalyticsToolbarProps = {
  children: ReactNode
  actions?: ReactNode
}

export const AnalyticsToolbar = ({ children, actions }: AnalyticsToolbarProps) => {
  return (
    <S.Container>
      <S.Content>{children}</S.Content>
      <S.Actions>{actions}</S.Actions>
    </S.Container>
  )
}
